<template>
    <div>
      <!-- 标签或分类名 -->
      <!-- <div class="banner" :style="cover">
        <h1 class="banner-title animated fadeInDown">{{ title }} - {{ name }}</h1>
      </div> -->

      <div v-show="!isvaildcheck" class="centerContainer">
      <button class="imgButton" @click="checkIsAdmin">
        <svg width="96" height="96" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="showLock">
          <rect x="6" y="22" width="36" height="22" rx="2" fill="none" stroke="#333" stroke-width="4" stroke-linejoin="round"/>
          <path d="M14 22V14C14 8.47715 18.4772 4 24 4C29.5228 4 34 8.47715 34 14V22" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24 30V36" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg width="96" height="96" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="!showLock">
          <rect x="7" y="22.0476" width="34" height="22" rx="2" fill="none" stroke="#333" stroke-width="4" stroke-linejoin="round"/>
          <path d="M14 22V14.0047C13.9948 8.87022 17.9227 4.56718 23.0859 4.05117C28.249 3.53516 32.9673 6.97408 34 12.0059" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24 30V36" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <el-dialog title="身份校验" :visible.sync="isAdminDialog" width="30%">
              <el-form ref="paperform" :inline="true" :model="admincheck" label-width="80px">
                <el-row>
                  <el-col :span="24">
                  <el-form-item label="密码" prop="pass">
                      <el-input v-model="admincheck.password"></el-input>
                  </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

              <div slot="footer" class="dialog-footer">
                  <el-button @click="isAdminDialog = false; showLock = true;">取 消</el-button>
                  <el-button type="primary" @click="vaildIsAmind">确 认</el-button>
              </div>
      </el-dialog>
    </div>

      <div v-show="isvaildcheck" class="book-list-wrapper">

        <div class="search-input-wrapper">
          <v-icon>mdi-magnify</v-icon>
          <input v-model="bookey" placeholder="请输入书籍名称" />
        </div>
        <!-- <el-tooltip content="这是一个小气泡" placement="top" effect="dark">
          <el-button class="type-tip">科幻</el-button>
        </el-tooltip> -->

        <!-- <div class="tips-contain">
          <el-button class="type-tip" style="background-color: #87CEEB;">科幻</el-button>
          <el-button class="type-tip" style="background-color: #6ae05a;">经济</el-button>
          <el-button class="type-tip" style="background-color: #d9e05a;">计算机</el-button>
          <el-button class="type-tip" style="background-color: #e05a77;">历史</el-button>
          <el-button class="type-tip" style="background-color: #f081c054;">教育</el-button>
        </div> -->
        
        <v-row>
          <v-col md="4" cols="12" v-for="item of localList" :key="item.id" style="text-align: center">
            <v-card class="animated zoomIn book-item-card">
              <div class="article-item-info">
                <div>
                  <router-link :to="'/book-' + item.type + '/' + item.id">
                    {{ item.name }}
                  </router-link>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <hr class="divider" v-show="localList != null"/>

        <v-row>
          <v-col md="4" cols="12" v-for="item of bookList" :key="item.id" style="text-align: center">
            <v-card class="animated zoomIn book-item-card">
              <div class="article-item-info">
                <div>
                  <router-link  :to="'/book-' + item.type + '/' + item.id">
                    {{ item.title }}
                  </router-link>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <infinite-loading @infinite="infiniteHandler">
          <div slot="no-results" />
          <div slot="no-more" />
        </infinite-loading>
      </div>
    </div>
  </template>
  
  <script>
  import {getBookLst, getBookLstByKey, rightCheck} from '../../api'
  export default {
    metaInfo:{
      meta: [{
        name: 'keyWords',
        content: "个人笔记的分享,开源博客,www.letmecode.cn"  //变量或字符串
      }, {
        name: 'description',
        content: "一个专注于技术分享的博客平台,大家以共同学习,乐于分享,拥抱开源的价值观进行学习交流"
      }]
    },
    created() {
      this.admincheck.password = localStorage.getItem("paperPossword");
      if (this.admincheck.password != null) {
        console.log(this.admincheck.password);
        this.vaildIsAmind();
      }
      const path = this.$route.path;
    },
    data: function() {
      return {
        bookey: "",
        current: 1,
        img: process.env.VUE_APP_IMG_API,
        size: 36,
        bookList: [],
        localList: [],
        name: "",
        title: "",
        isvaildcheck: false,
        showLock: true,
        isAdminDialog: false,
        admincheck: {
          password: "",
        },
      };
    },
    mounted(){
      this.localList = JSON.parse(localStorage.getItem("localList"));
    },
    methods: {
      loadBook() {
        getBookLst({
          pageNo: this.current,
          pageSize: this.size
        }).then(res => {
            res.data.forEach(v => {
              this.bookList.push({id: v.id, title: v.name, type: v.type})
            })
        });
        this.current += 1;
      },
      checkIsAdmin() {
        this.isAdminDialog = true;
        this.showLock = false;
      },
      vaildIsAmind() {
        this.isAdminDialog = false;
        let param = {
          tb_name: "t_paper",
          password: this.admincheck.password
        }
        rightCheck(param).then(res=>{
            localStorage.setItem("paperPossword", this.admincheck.password);
            this.isAdminDialog = false;
            this.isvaildcheck = true;
        })
      },
      infiniteHandler($state) {
        getBookLst({
              pageNo: this.current,
              pageSize: this.size
            }).then(res => {
            if (res.data.name) {
              this.name = res.data.name;
              document.title = this.title + " - " + this.name;
            }
            if (res.data.length) {
              this.current++;
              res.data.forEach(v => {
                this.bookList.push({id: v.id, title: v.name, type: v.type})
              })
              $state.loaded();
            } else {
              $state.complete();
            }
            
          });
      }
    },
    computed: {
      cover() {
        var cover = "";
        this.$store.state.blogInfo.pageList.forEach(item => {
          if (item.pageLabel == "bookList") {
            cover = item.pageCover;
          }
        });
        return "background: url(" + cover + ") center center / cover no-repeat";
      }
    },
    watch: {
      bookey(value) {
        console.log(value == "")
        if (value == ""){
          this.current = 1;
          this.bookList = [];
        }else{
          getBookLstByKey(value).then(res => {
          this.bookList = []
          res.data.forEach(v => {
            this.bookList.push({id: v.id, title: v.name, type: v.type})
          })
        });
        }
      }
    }
  };
  </script>
  
  <style scoped>
  @media (min-width: 760px) {
    .book-list-wrapper {
      max-width: 1106px;
      margin: 50px auto 1rem auto;
    }
    .book-item-card:hover {
      transition: all 0.3s;
      box-shadow: 0 4px 12px 12px rgba(7, 17, 27, 0.15);
    }
    .book-item-card:not(:hover) {
      transition: all 0.3s;
    }
    .book-item-card:hover .on-hover {
      transition: all 0.6s;
      transform: scale(1.1);
    }
    .book-item-card:not(:hover) .on-hover {
      transition: all 0.6s;
    }
    .article-item-info {
      line-height: 1.7;
      padding: 15px 15px 12px 18px;
      font-size: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  @media (max-width: 759px) {
    .book-list-wrapper {
      margin-top: 100px;
      padding: 0 12px;
    }
    .article-item-info {
      line-height: 1.7;
      padding: 15px 15px 12px 18px;
    }
  }
  .book-item-card {
    border-radius: 8px !important;
    box-shadow: 0 4px 8px 6px rgba(7, 17, 27, 0.06);
  }
  .book-item-card a {
    transition: all 0.3s;
  }
  .article-item-cover {
    height: 220px;
    overflow: hidden;
  }
  .book-item-card a:hover {
    color: #8e8cd8;
  }
  .tag-wrapper {
    padding: 10px 15px 10px 18px;
  }
  .tag-wrapper a {
    color: #fff !important;
  }
  .tag-btn {
    display: inline-block;
    font-size: 0.725rem;
    line-height: 22px;
    height: 22px;
    border-radius: 10px;
    padding: 0 12px !important;
    background: linear-gradient(to right, #bf4643 0%, #6c9d8f 100%);
    opacity: 0.6;
    margin-right: 0.5rem;
  }
  .search-input-wrapper {
    display: flex;
    /* padding: 5px; */
    height: 60px;
    width: 50%;
    border: 3px solid  rgb(113, 114, 114);
    border-radius: 1rem;
    /* margin-bottom: 3%; */
    margin: 0 auto 3%; /* 设置上外边距为30px，左右外边距为auto实现水平居中 */
  }
  .search-input-wrapper:hover, .search-input-wrapper:focus-within {
      transition: all 0.3s;
      border: 3px solid  rgb(7, 184, 238);
      box-shadow: 0 2px 6px 6px rgba(165, 165, 240, 0.646);
  }
  .search-input-wrapper input {
    width: 100%;
    margin-left: 5px;
    outline: none;
  }

  .type-tip{
    border-radius: 20px;
  }

  .tips-contain{
    margin-bottom: 3%;
    margin-top: 1%;
    margin-left: 30%;
  }

  .divider {
    margin: 20px 0;
    border: 2px dashed #d2ebfd;
  }
</style>
  